(() => {
  if (window.BdmImmersiveHeaderLoaded) return;
  window.BdmImmersiveHeaderLoaded = true;

  let ticking = false;

  function isMenuOpen() {
    const menu = document.querySelector('details.menu-drawer-container');
    return Boolean(menu && menu.hasAttribute('open'));
  }

  function updateImmersiveHeader() {
    const header = document.querySelector('.bdm-header--home');
    const hero = document.querySelector('.bdm-home-hero');

    if (!header || !hero) {
      document.documentElement.classList.remove('bdm-immersive-home');
      ticking = false;
      return;
    }

    const headerHeight = header.getBoundingClientRect().height;
    const heroRect = hero.getBoundingClientRect();
    const isOverHero = heroRect.bottom > headerHeight + 10;
    const menuOpen = isMenuOpen();

    document.documentElement.classList.add('bdm-immersive-home');

    /*
      IMPORTANT : l'ouverture / fermeture du menu reste 100 % gérée par Dawn
      (global.js / HeaderDrawer). Ici on ne touche jamais à :
      - l'attribut open du <details>
      - la classe menu-opening
      - shopify-section-header-hidden / sticky
      - aria-expanded / aria-hidden du tiroir

      On change seulement l'apparence du header pendant que le menu est ouvert.
    */
    if (menuOpen) {
      header.classList.remove('is-over-hero');
      header.classList.add('is-past-hero');
    } else {
      header.classList.toggle('is-over-hero', isOverHero);
      header.classList.toggle('is-past-hero', !isOverHero);
    }

    hero.classList.toggle('bdm-home-hero--visible', isOverHero);

    document.documentElement.style.setProperty(
      '--bdm-header-height',
      `${headerHeight}px`
    );

    ticking = false;
  }

  function requestHeaderUpdate() {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(updateImmersiveHeader);
  }

  function bindMenuAppearanceSync() {
    const menu = document.querySelector('details.menu-drawer-container');
    if (!menu || menu.dataset.bdmImmersiveAppearanceBound === 'true') return;

    menu.dataset.bdmImmersiveAppearanceBound = 'true';

    /*
      Le toggle sert uniquement à recalculer les couleurs du header.
      Dawn reste l'unique propriétaire du fonctionnement du tiroir.
    */
    menu.addEventListener('toggle', requestHeaderUpdate);
  }

  function initImmersiveHeader() {
    bindMenuAppearanceSync();
    updateImmersiveHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImmersiveHeader);
  } else {
    initImmersiveHeader();
  }

  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
  window.addEventListener('resize', requestHeaderUpdate);
  window.addEventListener('pageshow', requestHeaderUpdate);

  document.addEventListener('shopify:section:load', () => {
    bindMenuAppearanceSync();
    requestHeaderUpdate();
  });

  document.addEventListener('shopify:section:reorder', () => {
    bindMenuAppearanceSync();
    requestHeaderUpdate();
  });
})();